import {
  normalizeMapConfig,
  stringifyMapConfig,
} from '#components/document-viewer/map/map-config';
import {
  normalizeMessageConfig,
  stringifyMessageConfig,
} from '#components/document-viewer/message/message-config';

import {
  GRID_V1_CELL_FORMATS,
  type GridV1CellFormat,
  type GridV1Widget,
} from './grid-v1-types';

const CELL_ID_PATTERN = /^cell-(\d+)$/;
const GRID_V1_CELL_FORMAT_SET = new Set<string>(GRID_V1_CELL_FORMATS);

export interface GridV1CellContent {
  format: GridV1CellFormat;
  value: string;
}

export function normalizeGridV1CellFormat(value: unknown): GridV1CellFormat {
  return typeof value === 'string' && GRID_V1_CELL_FORMAT_SET.has(value)
    ? (value as GridV1CellFormat)
    : 'markdown-v1';
}

export function createDefaultGridV1CellContent(
  format: GridV1CellFormat = 'markdown-v1',
): GridV1CellContent {
  switch (format) {
    case 'np-map':
      return {
        format,
        value: stringifyMapConfig(normalizeMapConfig({})),
      };
    case 'np-message':
      return {
        format,
        value: stringifyMessageConfig(normalizeMessageConfig({})),
      };
    case 'markdown-v1':
      return { format, value: '' };
  }
}

export function nextGridV1CellId(widgets: GridV1Widget[]): string {
  let max = 0;
  for (const widget of widgets) {
    const match = CELL_ID_PATTERN.exec(widget.id);
    if (match) {
      const n = Number.parseInt(match[1] ?? '0', 10);
      if (n > max) max = n;
    }
  }
  return `cell-${max + 1}`;
}

export function defaultNewGridV1WidgetLayout(columnCount = 12): {
  w: number;
  h: number;
} {
  const columns = columnCount > 0 ? columnCount : 12;
  return {
    w: Math.min(6, columns),
    h: 3,
  };
}
